import IAGHeader from './IAGHeader';
export default IAGHeader;
